import {
	AlertActions,
	AlertModal,
	MainFooter,
	MainHeader,
	Snackbar,
	StyledGrid,
} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {FormProvider} from 'react-hook-form';
import {CustomContainer, CustomStyledGridItem} from '../../styles';
import {AddTherapyContentForm} from './components/AddTherapyContentForm';
import {useAddTherapy} from './hooks/useAddTherapy';

const {flowTitle, add, addTherapy, edit, editTherapy, quitModal} =
	translations['pt-br'].privateFlow.refund.therapies;

export const AddTherapy = () => {
	const {
		isEditPageMode,
		handleOpenGoBackModal,
		isTablet,
		therapyDataMethods,
		therapySessionsRef,
		handleCloseQuitModal,
		handleBackToList,
		openGoBackModal,
		setErrorState,
		errorState,
	} = useAddTherapy();

	return (
		<>
			<MainHeader
				title={isEditPageMode ? editTherapy : addTherapy}
				handleBack={isEditPageMode ? undefined : handleOpenGoBackModal}
				variant="route"
				breadcrumbs={[
					{
						title: flowTitle,
						callback: isEditPageMode ? undefined : handleOpenGoBackModal,
					},
					{title: isEditPageMode ? edit : add},
				]}
				handleClose={isEditPageMode ? undefined : handleOpenGoBackModal}
				id="add-therapy-header"
				hideProfileMenu
			/>
			<CustomContainer>
				<StyledGrid.Root marginTop={isTablet ? 0 : 2} px={isTablet ? 0 : 3} spacing={2}>
					<CustomStyledGridItem md={12} lg={12}>
						<FormProvider {...therapyDataMethods}>
							<AddTherapyContentForm ref={therapySessionsRef} />
						</FormProvider>
					</CustomStyledGridItem>
				</StyledGrid.Root>
			</CustomContainer>
			<AlertModal
				footerContent={
					<AlertActions
						primaryAction={handleCloseQuitModal}
						secondaryAction={handleBackToList}
						primaryText={quitModal.primaryActionText}
						secondaryText={quitModal.secondaryActionText}
						flexDirection="column-reverse"
					/>
				}
				headerTitle={quitModal.headerTitle}
				title={quitModal.title}
				description={quitModal.description}
				open={openGoBackModal.open}
				onClose={handleCloseQuitModal}
				variant="info"
				customIconName="info-filled"
			/>
			<Snackbar
				onClose={() => setErrorState(null)}
				message={errorState?.message}
				open={!!errorState}
				anchorOrigin={{vertical: 'top', horizontal: 'right'}}
				autoHideDuration={5000}
			/>
			<MainFooter />
		</>
	);
};
